import { render } from "./GifJudgement.vue?vue&type=template&id=4743e074&scoped=true"
import script from "./GifJudgement.vue?vue&type=script&lang=js"
export * from "./GifJudgement.vue?vue&type=script&lang=js"

import "./GifJudgement.vue?vue&type=style&index=0&id=4743e074&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4743e074"

export default script